export default "__VITE_ASSET__Bcu8y0l8__"